const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- app-signin ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    error: String,
  }

  init() {
    this.state.busy = ''
    this.state.keyError = ''
  }

  authcog() {
    this.state.busy = 'authcog'
    window.App.signIn()
  }

  async submit(event) {
    event.preventDefault()
    const key = (this.formData(event.target).key || '').trim()
    this.state.keyError = key ? '' : 'Enter your login key'
    if (!key) return
    this.state.busy = 'key'
    try {
      await window.App.api('auth/key_login', { key }, { silent: true })
      await window.App.boot()
    } catch (error) {
      this.state.keyError = error.details?.key || error.message
      this.state.busy = ''
    }
  }

  CSS = `:fez {
display:block;height:100%;.page{display:grid;place-items:center;min-height:100vh;padding:var(--space-6);background:radial-gradient(1200px 600px at 10% -10%,var(--color-accent-soft),transparent 60%),radial-gradient(900px 500px at 110% 110%,var(--color-accent-soft),transparent 60%),var(--color-bg-subtle)}.card{width:100%;max-width:400px;text-align:center}.form{display:grid;gap:var(--space-4);text-align:left}.mark{display:inline-grid;place-items:center;width:56px;height:56px;margin-bottom:var(--space-5);border-radius:var(--radius-xl);background:var(--color-accent);color:var(--color-accent-text);box-shadow:var(--shadow-md)}h1{font-size:var(--text-2xl);letter-spacing:-0.02em}.lead{margin:var(--space-2) 0 var(--space-8);color:var(--color-text-muted)}.error{display:flex;align-items:flex-start;gap:var(--space-2);margin-bottom:var(--space-5);padding:var(--space-3);border-radius:var(--radius-md);background:var(--color-danger-soft);color:var(--color-danger);font-size:var(--text-sm);text-align:left}.or{display:flex;align-items:center;gap:var(--space-3);margin:var(--space-5) 0;color:var(--color-text-subtle);font-size:var(--text-xs);text-transform:uppercase;letter-spacing:0.06em;&::before,&::after{content:'';flex:1;border-top:1px solid var(--color-border)}}.fine{margin-top:var(--space-6);color:var(--color-text-subtle);font-size:var(--text-xs)}
}`

  HTML = `<div class="page">
<div class="card">
<div class="ui-card elevated pad-xl">
<span class="mark"><ui-icon name="envelope-simple" size="30" weight="fill"></ui-icon></span>
<h1>MailCog</h1>
<p class="lead">Shared inboxes for your team, one isolated store per container.</p>
{#if props.error}
<div class="error" role="alert"><ui-icon name="warning-circle" size="18"></ui-icon><span>{props.error}</span></div>
{/if}
<ui-button variant="primary" size="lg" block label="Login via AuthCog" icon_right="arrow-right" loading={state.busy === 'authcog'} onclick="fez.authcog()"></ui-button>
<div class="or">or</div>
<form class="form" onsubmit="fez.submit(event)" novalidate>
<ui-input name="key" type="password" label="Login key" placeholder="48 letters and digits" error={state.keyError} mono></ui-input>
<ui-button type="submit" size="lg" block icon="key" label="Login with key" loading={state.busy === 'key'}></ui-button>
</form>
<p class="fine">AuthCog: Google, GitHub, Microsoft or an email code. We only receive your name, email and avatar.</p>
</div>
</div>
</div>`
};
}

Fez('app-signin', __fez_component_0);

export default __fez_component_0;
